// extracted by mini-css-extract-plugin
module.exports = {"mobileStep":"mobileStep-Cgxwr","content":"content-1tIVg","paper":"paper-2AXih"};